export default __webpack_public_path__ + "static/media/maskface.86f45450.png";